<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h1 class="mb-3">{{ $t('orders.orders_and_bulk_orders') }}</h1>
        <!-- all orders -->
        <div class="d-flex justify-space-between">
            <h3 class="mb-3">{{ $t('orders.all_orders') }}</h3>
            <v-switch
                v-model="form.including_orders_from_bulk_order"
                :label="$t('orders.including_orders_from_bulk_order')"
            />
        </div>
        <orders-table
            url="/api/orders"
            :including-orders-from-bulk-order="form.including_orders_from_bulk_order"
        />
        <!-- bulk orders -->
        <h3 class="mb-3">{{ $t('orders.all_bulk_orders') }}</h3>
        <bulk-orders-table url="/api/bulk-orders"/>
    </layout-authenticated>
</template>

<script>
import OrdersTable from '@/components/user/orders/OrdersTable'
import BulkOrdersTable from '@/components/user/orders/BulkOrdersTable'
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: "Orders",
    components: {LayoutAuthenticated, BulkOrdersTable, OrdersTable},
    data: () => ({
        form: {
            including_orders_from_bulk_order: false
        }
    }),
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/'
                },
                {
                    text: this.$t('orders.orders_and_bulk_orders'),
                    href: '/orders',
                    disabled: true
                }
            ];
        }
    }
}
</script>
